import { compileGrammar } from 'util/parserUtils'
import nearley from 'nearley'

const decimal = `
  DECIMAL -> "-":? [0-9,]:* ("." [0-9]:+):? {%
      function(d) {
          return (d[0] || "") +
              d[1].join("") +
              (d[2] ? "."+d[2][1].join("") : "")
      }
  %}
`
const scale = `SCALE -> "k" | "m" | "b" | "K" | "M" | "B" | null`

const dollarSignOpt = `DOLLAROPT -> null | "$"`

const dollarsGrammar = compileGrammar(`
  MAIN -> DOLLAROPT _ DECIMAL _ SCALE {% function(data) { return data[2] + data[4] } %}
  ${scale}
  ${dollarSignOpt}
  ${decimal}
  _ -> " " | null
`)

const sharesDollarsRangeGrammar = compileGrammar(`
    MAIN -> SINGLE | RANGE
    RANGE -> SINGLE _ RANGEDELIMETER _ SINGLE {% function(data) { return {min: data[0], max: data[4]} } %}
    SINGLE -> DOLLAROPT _ DECIMAL _ SCALE _ SHARESOPT {% function(data) { return {value: data[2] + data[4], isShare: !!data[6].length, hasDollarSign: !!data[0].length} } %}
    RANGEDELIMETER -> "-" | "to"i
    SCALE -> "k" | "m" | "b" | "K" | "M" | "B" | null
    DOLLAROPT -> null | "$"
    SHARESOPT -> "s" | "shares"i | "S" | "share" | "Share" | "sh" | "shr" | "shrs" | "SH" | "Sh" | null
    ${decimal}
    _ -> " " | null
    `)

const priceValuationGrammar = compileGrammar(`
    MAIN -> DOLLAROPT _ DECIMAL _ SCALE _ NETOPT GROSSOPT _ PRICETYPE {% data => ({value: data[2] + data[4], ...(!!data[6] ? data[6][0] : { isNtb: false, isNts: false })}) %}
    SCALE -> "k" | "m" | "b" | "K" | "M" | "B" | null
    DOLLAROPT -> null | "$"
    NETOPT -> NETTOBUYER | NETTOSELLER | null {% data => data[0] %}
    NETTOBUYER -> NTB {% data => ({ isNtb: true, isNts: false }) %}
    NETTOSELLER -> NTS {% data => ({ isNtb: false, isNts: true }) %}
	NTB -> "NTB"i
	NTS -> "NTS"i
    GROSSOPT ->  "g" | "gross" | "G" | "Gross" | null
    PRICETYPE -> "per share" | "pps" | "val" | null
    ${decimal}
    _ -> " " | null
`)

const singleConditionGrammar = compileGrammar(`
    MAIN -> NAME SPACE OPERATOR SPACE VALUE {% data => ({name: data[0][0].join(""), op: data[2][0], value: Array.isArray(data[4][0]) ? data[4][0].flat() : data[4][0] }) %}
    NAME -> [0-9a-zA-Z_.]:+
    OPERATOR -> "gt" | "lt" | "ge" | "le" | "!=" | "=" | "<" | ">" | "~=" | "in" | "contains"
    VALUE -> VALSTRING | VALARRAY
    VALARRAY -> "[" VALCOMMA:* VALSTRING "]" {% data => [...data[1], data[2]] %}
    VALCOMMA -> VALSTRING "," {% data => data[0] %}
    VALSTRING -> QUOTEDVAL | VAL
    QUOTEDVAL -> ["] VAL ["] {% data => data[1] %}
    VAL -> ([0-9a-zA-Z] | " " | "_" | ":" | "-" | "<" | ">" | "+" | "/" | "$"):+ {% data => data[0].join("") %}
    _ -> SPACE | null
    SPACE -> " "
`)

const multiConditionGrammar = compileGrammar(`
    MAIN -> INCLUDEORNULL _ AND _ EXCLUDEORNULL {% data => ({include: data[0][0] || [], exclude: data[4][0] || []}) %}
    INCLUDEORNULL -> INCLUDE | null
    EXCLUDEORNULL -> EXCLUDE | null
    INCLUDE -> "(" COND ")" {% data => data[1] %}
    EXCLUDE -> "(not (" COND "))" {% data => data[1] %}
    AND -> "and" | null
    COND -> CONDOR:* SIMPLECOND {% data => [...data[0], data[1]] %}
    CONDOR -> SIMPLECOND _ "or" _ {% data => data[0] %}
    SIMPLECOND -> "(" CONDSTRING ")" {% data => data[1] %}
    CONDSTRING -> ([0-9a-zA-Z] | " " | "[" | "]" | "<" | ">" | "=" | "!" | "~" | "," | ["] | "-" | "." | ":" | "_" | "+" | "/" | "$" ):+ {% data => data[0].join("") %}
    _ -> " " | null
`)

const sharesDollarsRangeGrammarCompiled = nearley.Grammar.fromCompiled(sharesDollarsRangeGrammar as any)
const priceValuationGrammarCompiled = nearley.Grammar.fromCompiled(priceValuationGrammar as any)
const singleConditionGrammarCompiled = nearley.Grammar.fromCompiled(singleConditionGrammar as any)
const multiConditionGrammarCompiled = nearley.Grammar.fromCompiled(multiConditionGrammar as any)
const dollarsGrammarCompiled = nearley.Grammar.fromCompiled(dollarsGrammar as any)

export const makeConditionParser = () => new nearley.Parser(singleConditionGrammarCompiled)
export const makeMultiConditionParser = () => new nearley.Parser(multiConditionGrammarCompiled)
export const makeRangeParser = () => new nearley.Parser(sharesDollarsRangeGrammarCompiled)
export const makePriceValuationParser = () => new nearley.Parser(priceValuationGrammarCompiled)
export const makeDollarsParser = () => new nearley.Parser(dollarsGrammarCompiled)
